import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Small "Write with AI" button: asks the backend writer and hands the text back via onResult. */
export const AiWriteButton = ({ task, context, headers, onResult, label = "Write with AI", testId }) => {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/ai/write`, { task, context }, { headers });
      onResult(data.text);
      toast.success("Draft ready — edit it as you like");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "AI writer unavailable right now");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={run}
      disabled={busy}
      className="inline-flex items-center gap-1.5 rounded-full border border-[#D4AF37]/50 px-3 py-1 text-[11px] font-medium text-[#8A6D1F] transition-colors hover:bg-[#D4AF37] hover:text-[#1B3A6B] disabled:opacity-60"
    >
      <Sparkles size={12} /> {busy ? "Writing…" : label}
    </button>
  );
};
